import { ComponentPropsWithoutRef, FC } from "react";

import { cn } from "@/lib/cn";

interface ButtonGroupProps extends ComponentPropsWithoutRef<"div"> {
  orientation?: "horizontal" | "vertical";
}

export const ButtonGroup: FC<ButtonGroupProps> = ({ className, orientation = "horizontal", ...props }) => (
  <div
    role="group"
    data-orientation={orientation}
    className={cn(
      "flex w-fit items-stretch [&>*]:relative [&>*:focus-visible]:z-10",
      orientation === "horizontal"
        ? "[&>*:not(:first-child)]:rounded-l-none [&>*:not(:last-child)]:rounded-r-none [&>*:not(:first-child)]:border-l-0"
        : "flex-col [&>*:not(:first-child)]:rounded-t-none [&>*:not(:last-child)]:rounded-b-none [&>*:not(:first-child)]:border-t-0",
      className,
    )}
    {...props}
  />
);
